import React, { useState } from 'react'
import { FeedbackForm, IQuestion } from '../FeedbackForm';
import XAPI, { Statement } from "@xapi/xapi";
import { v4 as uuidv4 } from 'uuid';

import './CourseCard.scss';

export interface ICourse {
    id: string,
    title: string,
    description: string,
    previewImageUrl: string,
    courseUrl: string,
    enableReporting: boolean,
    enableFeedback: boolean,
    feedbackUrl: string,
    questions?: IQuestion[]
}

export interface ICourseCardProps {
    course: ICourse
}

export enum CardState {
    READY = 1,
    INPROGRESS = 2,
    LAUNCHED = 3,
    FEEDBACK = 4,
    COMPLETED = 5
}

export const CourseCard = (props: ICourseCardProps) => {
    const [cardState, setCardState] = useState(CardState.READY);

    const courseClickHandler = (ev: any) => {
        /* stop default action */
        ev.preventDefault();
        /* check if in progress */
        if (cardState === CardState.INPROGRESS) {
            return;
        }
        /* change state */
        setCardState(CardState.INPROGRESS);
        /* get url and open window */
        let url = `/${props.course.enableReporting ? 'launch' : 'content'}/${props.course.courseUrl}`;
        let courseWindow = window.open(url);
        if (courseWindow) {
            courseWindow.addEventListener(
                "pagehide",
                (event) => {
                    /* change state */
                    if (props.course.enableFeedback && ((props.course.feedbackUrl && props.course.feedbackUrl.length > 0) || (props.course.questions && props.course.questions.length > 0))) {
                        setCardState(CardState.LAUNCHED);
                    } else {
                        setCardState(CardState.COMPLETED);
                    }
                });
        }
    };

    const feedbackClickHandler = (ev: any) => {
        /* url or questions */
        if (props.course.feedbackUrl && props.course.feedbackUrl.length) {
            window.open(props.course.feedbackUrl);
            setCardState(CardState.LAUNCHED);
        } else {
            setCardState(CardState.FEEDBACK);
        }
    };

    const feedbackCloseClickHandler = (ev: any) => {
        setCardState(CardState.LAUNCHED);
    };

    const feedbackSubmitHandler = (questions: any): Boolean => {

        /* setup lrs endpoint */
        const host: string = `${window.location.protocol}//${window.location.host}`;
        const lrs: XAPI = new XAPI(`${host}/data/xapi/`, "Basic Auth");

        const registration = uuidv4();
        const statements = [];
        try {
            for (let i = 0; i < questions.length; i++) {
                const question: IQuestion = questions[i];

                const statement: Statement = {
                    actor: {
                        objectType: "Agent",
                        mbox: "mailto:unknown@email.com",
                        name: "First Last"
                    },
                    verb: XAPI.Verbs.ANSWERED,
                    object: {
                        "objectType": "Activity",
                        "id": `${host}/${props.course.courseUrl}/${question.id}`,
                        "definition": {
                            "name": {
                                "en-US": question.question
                            }
                        }
                    }
                };
                if (question.selected) {
                    statement.result = {
                        response: JSON.stringify(question.selected),
                        completion: true,
                        success: true
                    };
                }
                //statement.generateId();
                statement.context = { "registration": registration };
                statements.push(statement);
            }
            lrs.sendStatements(statements);
        } catch (error) {
            return false;
        } finally {
            setCardState(CardState.COMPLETED);
            return true;
        }
    };

    return (
        <div className="col col-sm-6 col-lg-4 mb-4">
            <div className="card course-card">
                <div className={"course-card-front " + (cardState === CardState.FEEDBACK ? "d-none" : "")}>
                    <img className="card-img-top" src={`/content/${props.course.previewImageUrl}`} alt={props.course.title} />
                    <div className="card-body">
                        <h5 className="card-title">{props.course.title}</h5>
                        <p className="card-text">{props.course.description}</p>
                        {(cardState === CardState.LAUNCHED ?
                            <span>
                                <button className={"btn btn-lg btn-success"} onKeyPress={feedbackClickHandler} onClick={feedbackClickHandler}>Provide feedback</button>
                                <hr />
                            </span>
                            : "")}
                        <button className={"btn " + (cardState === CardState.READY ? "btn-lg btn-primary" : (cardState === CardState.INPROGRESS ? "btn-lg btn-secondary disabled" : "btn-sml btn-light"))} onKeyPress={courseClickHandler} onClick={courseClickHandler}>
                            {(cardState === CardState.READY ? "Launch" : "")}
                            {(cardState === CardState.INPROGRESS ? "In progress..." : "")}
                            {(cardState === CardState.LAUNCHED || cardState === CardState.COMPLETED ? "Relaunch" : "")}
                        </button>
                    </div>
                </div>
                <div className={"course-card-back " + (cardState !== CardState.FEEDBACK ? "d-none" : "")}>
                    <div className="card-header">
                        Feedback
                        <button type="button" className="btn-close" aria-label="Close" onClick={feedbackCloseClickHandler}></button>
                    </div>
                    <div className="card-body">
                        <FeedbackForm questions={props.course.questions} onSubmit={feedbackSubmitHandler} />
                    </div>
                </div>
            </div>
        </div>
    );
}

export default CourseCard;